import { useQuery } from "@tanstack/react-query";
import { ShipmentService } from "src/services/shipments";
import { queryKeys } from "src/constants";

const useShipmentStats = (shipmentService: ShipmentService) => {
  const { data, isLoading } = useQuery({
    queryKey: queryKeys.shipmentStats(),
    queryFn: () => shipmentService.getShipmentStats()
  });

  return {
    palletsReady: data?.palletsReady ?? 0,
    shipmentsReady: data?.shipmentsReady ?? 0,
    shipmentsBooked: data?.shipmentsBooked ?? 0,
    shipmentsDelivered: data?.shipmentsDelivered ?? 0,
    isLoading
  };
};

export { useShipmentStats };
